module.exports = __webpack_public_path__ + "img/tn-timeline-misc-5.413cdf44.jpg";